import {priority} from '@priority-software/priority-proto-api/lib';
import {updateFieldValue} from '../../../actions/form';
import {handleScreenMessage} from '../../../actions/screen';
import {fetchFormData} from '../../../../../services/form/form';
import {APIActionStatus, Form, formsStore, Record} from '../../../../../stores/Form';
import {Column} from '../../../../../stores/Form/Column';
import {RecordEditState} from '../../../../../stores/Form/enums';
import {createFiltersFromFilterParams} from '../../../actions/filters';
import {getFieldObjValueByName} from '../Common/utils';
import {MailboxSendFields, FileFields as RegularFileFields} from './consts';
import {common} from '@priority-software/priority-proto-api/lib';
import {AttachmentType} from '../../../../../components/FileUploader';
import {defaultSidePanelOptions} from '../Common/consts';

export const preDownload = async (file: Record) => {
    const form: Form = file.parentForm;
    const {session} = form;
    form.resetFilters();
    let filters = [];
    file.parentForm.keyColumns.forEach(col => {
        const filtersArr = createFiltersFromFilterParams([
            {fieldId: col.id, value: file.getField(col.id).origValue.toString()}
        ]);
        filters = [...filters, ...filtersArr];
    });

    const data: priority.netitems.form.FetchRs = await fetchFormData({
        session,
        filters,
        attachments: true,
        filtersOperator: priority.netitems.shared.LogicalOperator.And,
        options: defaultSidePanelOptions
    });
    return await handleScreenMessage(data, {}, () => {
        form.updateRecordValues(file.recordIndex, data.Records[0].Fields);
    });
};

export const getFileData = async (file: Record) => {
    const parentForm = file.parentForm;
    const FileFields =
        parentForm?.parentForm?.ename === 'MAILBOXSEND' ? MailboxSendFields : RegularFileFields;
    const fileData = getFieldObjValueByName(file, FileFields.fileData);
    if (fileData?.File?.Data?.length) {
        return fileData;
    } else {
        await preDownload(file);
        return getFieldObjValueByName(file, FileFields.fileData);
    }
};

export const fileFieldUpdate = async (
    column: Column,
    rowInd: number,
    attachement: AttachmentType
): Promise<APIActionStatus> => {
    const screen = formsStore.currentScreen;
    const form = formsStore.currentScreen.getActiveForm();
    const allowed = await screen.startRecordEdit(form);

    if (allowed) {
        const recordUpdateRes = await updateFieldValue(form, {
            ColumnID: column.ID,
            Value: new common.Constant({
                File: attachement
            })
        });
        // if message has error or warning message, we should let user to fix & update current value on the server
        screen.checkRecordErrorState(recordUpdateRes.Messages);

        return await handleScreenMessage(recordUpdateRes, {}, async res => {
            screen.editMode = RecordEditState.update;
            const updateRes = res || recordUpdateRes;
            form.updateRecordValues(rowInd, updateRes.Record.Fields);
        });
    }
    return APIActionStatus.blocked;
};
